module.exports = __webpack_public_path__ + "static/media/rupoli-1.43114f55.jpg";